var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZafSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 14C11.3138 14 14.0001 11.3137 14.0001 8C14.0001 4.68629 11.3138 2 8.00012 2C4.68641 2 2.00012 4.68629 2.00012 8C2.00012 11.3137 4.68641 14 8.00012 14Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75735 12.2426C1.41422 9.89947 1.41422 6.10049 3.75735 3.75732C3.75719 3.75758 7.21741 7.99998 7.21741 7.99998L3.75735 12.2426Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21743 8L2.79581 5.01202C2.65873 5.25031 2.53783 5.49903 2.43396 5.75647L4.67245 8.00002L2.43403 10.2437C2.53781 10.5009 2.65858 10.7495 2.79558 10.9876L7.21743 8Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9492 7.21741H7.21722L3.75729 3.75745C3.38445 4.13029 3.06052 4.55195 2.79577 5.01206L5.77793 8.00001L2.79553 10.9876C3.06028 11.4478 3.38435 11.8696 3.75729 12.2425L7.21722 8.78261H13.9492C13.9825 8.52644 14 8.26525 14 8.00001C14 7.73477 13.9825 7.47358 13.9492 7.21741Z",
    fill: "#00845A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34692 12.7596C5.3587 13.5373 6.62519 14 7.99994 14C10.7721 14 13.1047 12.1198 13.7932 9.56525H7.54133L4.34692 12.7596Z",
    fill: "#0058A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7932 6.43477C13.1047 3.88018 10.7721 2 7.99994 2C6.62519 2 5.3587 2.46268 4.34692 3.24038L7.54131 6.43477H13.7932Z",
    fill: "#D80027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZafSm);
export default __webpack_public_path__ + "static/media/ZAF-SM.9f7be9b8c16d0f492081c6a66be99d21.svg";
export { ForwardRef as ReactComponent };